import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select, IconButton } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, PersonAdd as IconPersonAdd } from "@mui/icons-material";
import * as terapiaService from "../../services/terapiaService";
import * as periodoService from "../../services/periodoService";
import * as filialService from "../../services/filialService";
import * as catalogoService from "../../services/catalogoService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setResults, setListPeriodos, setListFilial, setListTiposTerapias, setListEstados } from '../../redux/therapyPeriodSearchSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"

const Index = () => {
    const filters = useSelector((state) => state.therapyPeriodSearch.filters);
    const listPeriodos = useSelector((state) => state.therapyPeriodSearch.listPeriodos);
    const listFilial = useSelector((state) => state.therapyPeriodSearch.listFilial);
    const listTiposTerapias = useSelector((state) => state.therapyPeriodSearch.listTiposTerapias);
    const listEstados = useSelector((state) => state.therapyPeriodSearch.listEstados);
    
    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchResults = async () => {
        setCargando(true);

        await terapiaService.getsTerapiaPeriodoResumenView(filters)
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchPeriodos = async () => {
        await periodoService.getsPeriodoView({
                idTipoTerapia: 0,
                idEstadoApertura: 87,
                mesesHaciaAtras: 0,
                idEstado: 2,
            })
            .then((data) => {
                dispatch(setListPeriodos(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchListFilial = async () => {
        await filialService.getFilialesList()
            .then((data) => {
                dispatch(setListFilial(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchTiposTerapias = async () => {
        await catalogoService.getCatalogosByPadre(49)
            .then((data) => {
                dispatch(setListTiposTerapias(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchEstados = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstados(data));
                dispatch(setValue({name: "idEstado", value: 2}))
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const annulTerapiaPeriodo = async () => {
        await terapiaService.annulTerapiaPeriodo(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    const activeTerapiaPeriodo = async () => {
        await terapiaService.activeTerapiaPeriodo(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }

    useEffect(() => {
        fetchResults();
        fetchPeriodos();
        fetchListFilial();
        fetchTiposTerapias();
        fetchEstados();
    }, []);

    const columns = [
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'codigoServicio', headerName: 'Servicio', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'participante', headerName: 'Participante', width: 200, sortable: false, headerAlign: 'center'
            // , renderCell: (cellValues) => {
            //     return <Link to={'/therapyPeriod/edit/' + cellValues.row.idTerapia} style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            // }
        },
        { field: 'codigoFilial', headerName: 'Filial', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'codigoPeriodo', headerName: 'Periodo', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'terapeuta', headerName: 'Terapeuta', width: 200, sortable: false, headerAlign: 'center' },
        { field: 'estadoApertura', headerName: 'Apertura', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        // Comprobante generado al abrir el periodo: estado de pago, serie-numero
        // y saldo. El estado y el serie-numero enlazan al comprobante.
        { field: 'estadoPago', headerName: 'Pago', width: 100, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                const row = cellValues.row;

                if (!row.idComprobante || row.idComprobante == 0) return "";

                return <Link to={'/receipt/edit/' + row.idComprobante} style={{ color: 'inherit' }}>
                    {row.estadoPago}
                </Link>;
            }
        },
        { field: 'serieNumero', headerName: 'Comprobante', width: 110, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'montoSaldo', headerName: 'Saldo', width: 90, sortable: false, headerAlign: 'right', align: 'right'
            , valueFormatter: (value) => (parseFloat(value) || 0).toFixed(2) },
        // { field: 'codigoTarifa', headerName: 'Tarifa', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'salon', headerName: 'Salon', width: 100, sortable: true, headerAlign: 'center' },
        // { field: 'fechaInicio', headerName: 'Inicio', width: 120, type: 'date'
        //     , valueFormatter: (value) => moment(value).format('D/MM/YYYY')
        //     , sortable: true, headerAlign: 'center', align: 'center' },
        { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"} onClick={() => {
                    setSelectId(cellValues.row.id);
                    setSelectState(cellValues.row.estado);
                    setOpenDialogAnnulActive(true);
                }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Periodos de Terapia
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1} padding={0}>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-filial">Filial</InputLabel>
                                    <Select
                                        native
                                        label="Filial"
                                        value={filters.idFilial}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idFilial", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idFilial',
                                            id: 'input-filial',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listFilial.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-periodo">Periodo</InputLabel>
                                    <Select
                                        native
                                        label="Periodo"
                                        value={filters.idPeriodo}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idPeriodo", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idPeriodo',
                                            id: 'input-periodo',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listPeriodos.map((row) => (
                                            <option key={row.id} value={row.id}>{row.codigo}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-tipoterapia">Tipo Terapia</InputLabel>
                                    <Select
                                        native
                                        label="Tipo Terapia"
                                        value={filters.idTipoTerapia}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idTipoTerapia", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idTipoTerapia',
                                            id: 'input-tipoterapia',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listTiposTerapias.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} sm={2}>
                                <TextField
                                    name="participante"
                                    label="Participante"
                                    value={filters.participante}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "participante", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={8} sm={2}>
                                <TextField
                                    name="terapeuta"
                                    label="Terapeuta"
                                    value={filters.terapeuta}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "terapeuta", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado">Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstado", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstados.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                // onNewClick={() => navigate(`/therapyPeriod/open`)}
                                toolbarButtons={[
                                    {
                                        text: "Abrir",
                                        icon: <IconPersonAdd />,
                                        onClick: () => navigate("/therapyPeriod/open")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annulTerapiaPeriodo : activeTerapiaPeriodo} 
                        setNo={() => { return }}
                        titulo={(selectState == "A" ? "Anular" : "Activar") + " Periodo de Terapia"}
                        texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " el periodo de la terapia?"} >
                    </DialogYesNo>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index


